module.exports = __webpack_public_path__ + "img/roomi tv 32_frameless.db5ee864.jpg";